// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"925a93d1","453":"cfa8b985","732":"b09a93e6","977":"1a552b5e"}[chunkId] + ".chunk.js";
};